import dayjs from "dayjs"

export function getDateTime(value: string | null | undefined): string | null {
  if (!value) {
    return null
  }
  const date = dayjs(value)
  return date.utc(true).toISOString()
}
